export default __webpack_public_path__ + "static/media/license.7152b1ba.pdf";